import { c as _c } from "react/compiler-runtime";
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { OFFER_API } from '../api';
import { DigitalProductId } from '../types/digital-product-interface';
export function useOfferDigitalProductsCount(digitalProductId) {
  const $ = _c(7);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== digitalProductId || $[2] !== user) {
    t1 = () => user && digitalProductId && `${OFFER_API}/count-by-digital-product/${digitalProductId}`;
    $[1] = digitalProductId;
    $[2] = user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data: offerDigitalProductsCount,
    isLoading,
    isValidating
  } = useControlledSwr(t1, fetcher);
  const t2 = isLoading || isValidating;
  let t3;
  if ($[4] !== offerDigitalProductsCount || $[5] !== t2) {
    t3 = {
      offerDigitalProductsCount,
      isLoading: t2
    };
    $[4] = offerDigitalProductsCount;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}